'use client';

import { useCallback, useState } from 'react';

import IconFilter from 'app/components/sprites/IconFilter';
import Modal from 'app/components/common/Modal';
import ScheduleFilter, { IScheduleFilterFormFields } from './ScheduleFilter';
import classNames from 'classnames';

interface IProps {
  theme?: 'white' | 'brown';
  initialState: IScheduleFilterFormFields;
}

export default function ScheduleFilterMobile({
  theme = 'white',
  initialState
}: IProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      <button
        type="button"
        className={classNames(
          'relative flex justify-between items-center w-full py-3 px-4 text-h2 border rounded',
          {
            'text-white border-white': theme === 'white',
            'text-brown border-brown': theme === 'brown'
          }
        )}
        onClick={openModal}
      >
        <span>Фильтры</span> <IconFilter />
      </button>
      <Modal isOpen={isOpen} onClose={closeModal}>
        <ScheduleFilter initialState={initialState} onSubmit={closeModal} />
      </Modal>
    </>
  );
}
